module.exports = __webpack_public_path__ + "static/media/npac.72cc7200.jpg";